/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Tip_Decklists_TInputs */



/**
* | output |
* | --- |
* | "Collect decklists before the day" |
*
* @param {Tournament_Wiz_Tip_Decklists_TInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_tip_decklists_t = /** @type {((inputs?: Tournament_Wiz_Tip_Decklists_TInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Tip_Decklists_TInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Collectez les decks avant le jour J")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recoja los decks antes del día")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Colete as listas de deck antes do dia")
	if (locale === "it") return /** @type {LocalizedString} */ ("Raccogli le decklist prima del giorno stesso")
	return /** @type {LocalizedString} */ ("Collect decklists before the day")
});